import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { getProjectData } from "../../../../store/Api";

export default function EmployeeFilter({
  filterPopUp,
  setFilterPopUp,
  setSelectedProject,
  SetListData,
}) {
  const dispatch = useDispatch();
  const Project = useSelector((state) => state.projectData);
  console.log("project data to be displayed here...", Project);
  const token = localStorage.getItem("token");
  useEffect(() => {
    dispatch(getProjectData(token));
  }, [filterPopUp]);
  const [data, setData] = useState();
  const handleProjectChange = (e) => {
    console.log("event to be triggred....", e.target.value);
    setData(e.target.value);
  };

  const onClearFilter = () => {
    setSelectedProject("");
    setData();
    setFilterPopUp(false);
    // SetListData([]);
  };

  const onFilterClick = () => {
    setFilterPopUp(false);
    setSelectedProject(data);
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          filterPopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setFilterPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="flex flex-col w-full gap-1 mt-6">
            <label htmlFor="" className="px-1">
              select project
            </label>
            <select
              //   {...register("visaprovider")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={handleProjectChange}
              value={data ? data : ""}
            >
              <option value="">{"SELECT VALUE"}</option>
              {Project?.data?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.project_id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex gap-3 w-full justify-center mt-6 mb-4">
            <button
              className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-blue text-white bg-blue"
              onClick={() => {
                onClearFilter();
              }}
            >
              CLEAR FILTER
            </button>
            <button
              className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
              onClick={() => {
                onFilterClick();
              }}
            >
              FILTER
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
